const prefix = 'calcRes@@'
export const CHANGE_PERIOD = `${prefix}CHANGE_CALC_DATE`
export const SET_LOADING = `${prefix}SET_LOADING`
export const STORE_SUM_DATA = `${prefix}STORE_SUM_DATA`
export const STORE_DETAIL_DATA = `${prefix}STORE_DETAIL_DATA`
export const STORE_EFORD_CONTRIB = `${prefix}STORE_EFORD_CONTRIB`
export const STORE_AG_EFORD = `${prefix}STORE_AG_EFORD`
export const STORE_KPI_SPEC = `${prefix}STORE_KPI_SPEC`
export const STORE_KPI_AG = `${prefix}STORE_KPI_AG`
export const STORE_KPI_CA_AG = `${prefix}STORE_KPI_CA_AG`
export const STORE_KPI_CONTRIB = `${prefix}STORE_KPI_CONTRIB`
export const STORE_KPI_CA_CONTRIB = `${prefix}STORE_KPI_CA_CONTRIB`
export const STORE_CONTRIB_KEYS = `${prefix}STORE_CONTRIB_KEYS`
export const STORE_CA_CONTRIB_KEYS = `${prefix}STORE_CA_CONTRIB_KEYS`
export const STORE_KPI_GOALS = `${prefix}STORE_KPI_GOALS `
export const STORE_YEAR = `${prefix}STORE_YEAR`
export const STORE_CA_DATA = `${prefix}STORE_CA_DATA`
export const STORE_WEEK_HOUR_DATA = `${prefix}STORE_WEEK_HOUR_DATA`
export const SET_SHOW_SELECTOR = `${prefix}SET_SHOW_SELECTOR`
export const STORE_GADS_SUMMARIZED_DATA = `${prefix}SET_GADS_SUMMARIZED_DATA`
export const STORE_GADS_MONTHLY_DATA = `${prefix}SET_MONTHLY_DATA`
export const STORE_PNL_WEEKLY_DATA = `${prefix}SET_SUMMARIZED_DATA`
